import { render, staticRenderFns } from "./LoginPopup.vue?vue&type=template&id=1533ba1c&"
import script from "./LoginPopup.vue?vue&type=script&lang=js&"
export * from "./LoginPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports